// Isolated so tests can mock navigation - jsdom's window.location is not configurable.
export function navigate(url: string): void {
  window.location.href = url;
}
